var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyExercise({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z",
    fill: "#FDF5F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6487 33.6049C85.5124 32.2135 83.4634 32.0072 82.072 33.1427L66.7394 45.6648L56.8901 43.8348L47.0792 26.6412C46.189 25.0823 44.2012 24.5374 42.6415 25.4277C41.081 26.3188 40.5378 28.3048 41.4281 29.8654L52.0688 48.5133L47.1278 75.1057L42.9688 97.4927C42.6407 99.2588 43.8065 100.957 45.5728 101.285C45.7736 101.322 45.973 101.34 46.1708 101.34C47.7074 101.34 49.0743 100.246 49.3649 98.6806L53.5242 76.2941L60.2977 77.5526C65.2293 84.1901 66.7724 91.0118 65.2597 99.1524C64.9316 100.919 66.0974 102.616 67.8637 102.944C68.0645 102.982 68.2639 103 68.4617 103C69.9983 103 71.3652 101.906 71.6558 100.34C73.4728 90.56 71.4712 81.8222 65.5724 73.7722L69.6804 51.663L86.1876 38.1814C87.5787 37.0459 87.7853 34.9963 86.6487 33.6049Z",
    fill: "#FE6036"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2417 38.4725C67.8346 38.4725 70.7473 35.5599 70.7473 31.9669C70.7473 28.374 67.8346 25.4614 64.2417 25.4614C60.6487 25.4614 57.7361 28.374 57.7361 31.9669C57.7361 35.5599 60.6487 38.4725 64.2417 38.4725Z",
    fill: "#FE6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyExercise);
export default __webpack_public_path__ + "static/media/My Exercise.efc1001507ffb7ae9cb9ab7176516a15.svg";
export { ForwardRef as ReactComponent };